<template>
    <div class="header_top">
        <div class="header-layer">
            <div class="header-left">
                <span @click="jumpIndex" style="cursor:pointer;">欢迎来到917厨房网！</span>
                <router-link :to="{path:'/marketlist?num=2'}" v-if="cityname.LngLatAddress">{{cityname.LngLatAddress}}【切换收货位置】</router-link>
                <router-link :to="{path:'/choosecity'}" v-else >{{cityname.twoName}}<span v-show="cityname.threeName">&nbsp;-</span>&nbsp;{{cityname.threeName}}</span>【切换城市】</router-link>
                <span v-if="!marketActObj" @click="setMarketClick" style="cursor:pointer;margin-left:60px;">选择菜场</span>
                <span v-else @click="setMarketClick" style="cursor:pointer;margin-left:60px">当前菜场：{{marketActObj.name}}</span>
            </div>
            <div class="header-right">
                <router-link
                    v-if="is_token"
                    class="link"
                    to="/order?index=0"
                >查看订单</router-link>
                <router-link
                    class="link"
                    to=""
                >帮助中心</router-link>
                <router-link
                    v-if="!is_token && user_status !== 'login'"
                    class="button header-reg-but"
                    style="margin-left: 15px;"
                    to="/login"
                >登录</router-link>
                <router-link
                    v-if="!is_token && user_status !== 'registered'"
                    class="button header-reg-but"
                    :class="user_status == ''?'header-reg-bac':''"
                    style="margin-left: 15px;"
                    to="/regist"
                >注册</router-link>
                <router-link
                    v-if="is_token"
                    class="link"
                    to=""
                >{{value}} </router-link>
                <router-link
                    v-if="is_token"
                    class="link"
                    to="/order?index=0&personal=5"
                >个人中心</router-link>
                <div
                    v-if="is_token"
                    class="link"
                    style="border:none;cursor:pointer"
                    to=""
                    @click="outLogin"
                >退出登录 </div>

            </div>
        </div>


        <!--退出登录弹窗-->
        <div
            class="reg-popup-bac req-popup-pos"
            v-if="is_popup"
        ></div>
        <div
            class="req-popup-pos reg-popup-wid dis-cen"
            v-if="is_popup"
        >
            <div class="reg-popup-box" style="height:auto">
                <!---->
                <div class="dis-between">
                    <div></div>
                    <div>温馨提示</div>
                    <img class="reg-popup-box-close" @click="closePopupImgClick" src="../../assets/image/iocn/close.png" />
                </div>
                <div class="reg-popup-box-login-p">您确定要退出登录吗？</div>
                <div class="dis-cen">
                    <div class="dis">
                        <div class="lkbuy-btnnew" @click="closePopupClick">取消</div>
                        <div class="add-shopcartnew" style="background: #929292;" @click="outLoginFn" >确定退出</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default
    {
        data()
        {
            return {
                cityname: {},
                username: '',
                is_token: false,
                divType: false,
                user_status: '', // 'registered', 'login', 'forgetPassword'
                value: '',
                is_popup: false,
                marketActObj: ''
            }
        },
        mounted()
        {
            if ( JSON.parse( localStorage.getItem( 'cityname' ) ) )
            {
                this.cityname = JSON.parse( localStorage.getItem( 'cityname' ) )
            }
            else
            {
                let a = { twoId: 331, twoName: '金华市', threeId: 332, threeName: '婺城区', LngLatAddress:'' }
                localStorage.setItem( "cityname", JSON.stringify( a ) )
                this.cityname = a
            }
            this.user_status = localStorage.getItem( 'userStatusHTop' )

            let addName = this.cityname.LngLatAddress
            let newAddName = ''
            if (addName.length > 10) {
                newAddName = addName.slice(0,10) + '...'
            } else {
                newAddName = addName
            }
            this.cityname.LngLatAddress = newAddName
        },
        created()
        {
            this.marketActObj = JSON.parse( localStorage.getItem( 'marketActObj' ) )
            this.$api.user.GetUserInfo().then( res =>
            {
                if ( res.data.code === 0 )
                {
                    localStorage.setItem( 'loginData2', JSON.stringify( res.data.result ) )
                    localStorage.setItem( 'vipCard', res.data.result.vipCard );

                    // +--------------------------------------------
                    let vipCard = localStorage.getItem( 'vipCard' )
                    let divType = localStorage.getItem( 'divType' )
                    if ( divType && divType !== 'null' ) this.divType = true
                    if ( localStorage.getItem( 'token' ) ) this.is_token = true
                    if ( vipCard && vipCard !== 'null' )
                    {
                        this.value = '会员号：' + vipCard
                    }
                    else
                    {
                        this.value = '用户名：' + localStorage.getItem( 'username' )
                    }
                }
            } )
        },
        methods:
        {
            setMarketClick() {
                if ( !this.is_token )
                {
                    this.$confirm( '选择菜场需要登录, 是否前往登录?', '提示',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    } ).then( () =>
                    {
                        this.go_login()
                    } ).catch( () =>
                    {
                        this.$message(
                        {
                            type: 'info',
                            message: '已取消'
                        } )
                    } )

                    return
                }
                let params = {PageNo: 1,PageSize: 30}
				this.$api.order.getAddress(params).then(res => {
					if (res.data.code == 0) {
						let addressList = res.data.result.data
                        if (addressList.length == 0) {
                            this.$confirm( '请先添加收货地址？', '提示',
                            {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then( () =>
                            {
                                this.$router.push( { path: '/order?index=0&personal=5' } )
                            }).catch( () =>
                            {
                                // ...
                            })
                        } else {
                            this.$router.push( { path: '/marketlist?num=1' } )
                        }
                    }
                })
            },
            go_login()
            {
                this.$router.push(
                {
                    path: '/login'
                } )
            },
            jumpIndex()
            {
                this.$router.push( { path: "/" } )
            },
            outLogin()
            {
                this.is_popup = true
                // this.$confirm( '您确定要退出登录吗?', '提示',
                // {
                //     confirmButtonText: '确定',
                //     cancelButtonText: '取消',
                //     type: 'warning'
                // } ).then( () =>
                // {
                //     localStorage.clear()
                //     this.$message(
                //     {
                //         type: 'success',
                //         message: '已退出登录!'
                //     } );
                //     this.$router.push(
                //     {
                //         path: '/login'
                //     } )

                // } ).catch( () =>
                // {
                //     this.$message(
                //     {
                //         type: 'info',
                //         message: '已取消退出登录'
                //     } );
                // } );
            },
            closePopupImgClick() {
                this.is_popup = false
            },
            outLoginFn() {
                localStorage.clear()
                this.$message(
                {
                    type: 'success',
                    message: '已退出登录!'
                } );
                this.$router.push(
                {
                    path: '/login'
                } )
            },
            closePopupClick() {
                this.is_popup = false
                this.$message(
                {
                    type: 'info',
                    message: '已取消退出登录'
                } );
            }

        }
    }
</script>
<style scoped>
    .header_top {
        background: #444444;
        height: 36px;
    }

    .header_top .header-layer {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 1200px;
        margin: 0 auto;
    }

    .header-left {
        line-height: 36px;
    }

    .header-left span,
    .header-left a {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, .6);
    }

    .header-left a {
        margin-left: 54px;
    }

    .header-right {
        display: flex;
        flex-direction: row;
    }

    .header-right .link {
        margin: 10px 0 10px;
        border-right: 1px solid #c3c3c3;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, .6);
        padding: 0 18px;
    }

    .header-right .button {
        width: 54px;
        height: 23px;
        border-radius: 5px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, .6);
        text-align: center;
        line-height: 23px;
        margin: 6.5px 0;
    }

    .header-right .button:nth-child(3) {
        margin-left: 15px;
        margin-right: 7px;
    }

    .header-right .button:nth-child(4) {
        border: 1px solid rgba(255, 255, 255, .6);
        border-radius: 5px;
        background-color: transparent;
    }

    .header-reg-but {
        background: #069338;
    }

    .header-reg-bac {
        border: 1px solid rgba(255, 255, 255, .6);
        background: #444444;
    }
    @import '../../assets/style/base.css'
</style>